export const MY_REPORT_ACL_OBJECTS = [
    'MyReportComponent'
];
